// import '../index.css';

import { useEffect } from "react";
import HeroAbout from "./component/About";
import Features from "./component/Features";
import Hero from "./component/Hero";
import ImmigrationCountries from "./component/ImmigrationCountries";
import NewsUpdates from "./component/NewsUpdates";
// import PartnerLogos from "./component/PartnerLogos";
import StatsSection from "./component/StatsSection";
import Testimonials from "./component/Testimonials";
// import TrainingSection from "./component/TrainingSection";
import VisaServices from "./component/VisaServices";
import WhyChooseVisarzo from "./component/WhyChooseVisarzo";




export default function Home() {

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, []);

    return (
        <>

            <Hero />
            <HeroAbout />
            <Features />
            <VisaServices />
            <StatsSection />
            {/* <TrainingSection /> */}
            <ImmigrationCountries />
            <WhyChooseVisarzo />
            <Testimonials />
            <NewsUpdates />
            {/* <PartnerLogos /> */}
        </>
    );
}
